import React from 'react';
import Icon from 'components/Icon';

import './m-tooltip-icon.scss';

export default class MTooltipIcon extends React.Component {
  onClick = e => {
    e.stopPropagation();

    if (this.props.url) {
      window.open(this.props.url, '_blank');
    }
  };

  render() {
    const { iconType, children, size = 24 } = this.props;
    return (
      <div
        className="tooltip-icon-wrapper"
        style={{
          width: size,
          height: size,
        }}
        onClick={this.onClick}
      >
        <Icon
          iconType={iconType || 'question'}
          className="tooltip-icon"
          tooltip={this.props.children}
        />
      </div>
    );
  }
}
